import { render, staticRenderFns } from "./AppS.vue?vue&type=template&id=38aada82&"
import script from "./AppS.vue?vue&type=script&lang=js&"
export * from "./AppS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports